<template>
  <b-spinner v-if="spinner" variant="success"></b-spinner>
  <a
    v-else
    @click="print(item)"
    v-html="get_print_html(item.tags.has_label)"
    style="cursor: pointer"
  ></a>
</template>

<script>
import axios from "axios";
import swal from "sweetalert2";
export default {
  props: ["item"],
  data() {
    return {
      spinner: false,
    };
  },
  methods: {
    update(has_label, ids) {
      this.spinner = true;
      axios
        .post("/api/documents/put_labels", {
          ids: ids,
          has_label: has_label,
        })
        .then((response) => {
          this.spinner = false;
          return true;
        })
        .catch((error) => {
          this.spinner = false;
          /*swal({
            title: "Ops!",
            text: "",
            type: "error",
          });*/
          return false;
        });
    },
    print(item) {
      var label = false;
      if (item.shipments.length) {
        if (item.shipments[0].documents.length) {
          var documents = item.shipments[0].documents;
          for (var i = 0; i < documents.length; i++) {
            var files = documents[i];
            if (files.type == "label") {
              window.open(files.url, "_blank");
              this.update(2, [this.item.id]);
              label = true;
            }
          }
        }
      }
      if (label) return true;
      this.print_labels([item.id]);
      return;
    },
    print_labels(orders_ids) {
      this.spinner = true;
      axios
        .post("/api/documents/get_labels", orders_ids)
        .then((response) => {
          if (response.data.urls) {
            response.data.urls.forEach(function (pdf_link) {
              let link = document.createElement("a");
              link.setAttribute("href", pdf_link);
              link.setAttribute("download", pdf_link);
              link.setAttribute("target", "_blank");
              link.style.display = "none";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              this.update(2, orders_ids);
            });
          } else {
            if (response.data.error) {
              if (response.data.error.orders) {
                var text =
                  "Ocorreu algum problema ao tentar gerar as etiquetas do(s) pedido(s)";

                for (var key in response.data.error.orders) {
                  text = text + "\n" + this.$t("Pedido") + " " + key;
                  for (var key2 in response.data.error.orders[key]) {
                    text = text + "\n" + response.data.error.orders[key][key2];
                  }
                }
              }

              if (response.data.error.config) {
                var text =
                  "Clique no linque abaixopara configurar o formato de impressão.";
              }

              swal({
                title: "Ops!",
                text:
                  "Ocorreu algum problema ao tentar gerar as etiquetas, " +
                  text,
                footer:
                  '<a href="http://beta.plugg.to/settings#labels" target="_parent">Clique aqui<a>',
                type: "error",
              });
            } else {
              swal({
                title: "Ops!",
                text: "Ocorreu algum problema ao tentar gerar as etiquetas do pedido, tente novamente em alguns instantes.",
                type: "error",
              });
            }
          }
          this.spinner = false;
        })
        .catch((error) => {
          this.spinner = false;
          swal({
            title: "Ops!",
            text: "Etiqueta não está disponível no momento, tente novamente mais tarde.",
            type: "error",
          });
        });
    },
    get_print_html(key) {
      var icon;
      var title;

      if (key == 0 || !key) {
        title = this.$t("Gerar etiqueta.");
        icon = '<i class="fas fa-receipt btn-edit" title="' + title + '"></i>';
      }

      if (key == 1) {
        title = this.$t("Etiqueta disponível para impressão");
        icon = '<i class="fas fa-receipt text-blue" title="' + title + '"></i>';
      }

      if (key == 2) {
        title = this.$t("Etiqueta Impressa");
        icon =
          '<i class="fas fa-receipt text-green" title="' + title + '"></i>';
      }

      if (key == 3) {
        title = this.$t("Erro na etiqueta");
        icon = '<i class="fas fa-receipt text-red" title="' + title + '"></i>';
      }

      return icon;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/Etiqueta.vue